import ApiConstants from "../../../constants/ApiConstants";

export const BUSINESS_TYPE = [
    { value: "soleProprietorship", label: "Sole Proprietorship" },
    { value: "partnership", label: "Partnership" },
    { value: "LLP", label: "LLP" },
    { value: "sCorporation", label: "S Corporation" },
    { value: "corporation", label: "Corporation" },
    { value: "LLC", label: "LLC" },
    { value: "nonProfitOrganization", label: "Non-Profit Organization" },
    { value: "501c3charitableOrganization", label: "501(c)(3) Charitable Organization" }
]

export const FEDERAL_FILTER_TYPE = [
    { value: "941", label: "Form 941" },
    { value: "944", label: "Form 944" }
]

export const FEDERAL_DEPOSIT_SCHEDULE = [
    { value: "annually", label: "Annually" },
    { value: "quarterly", label: "Quarterly" }
];

export interface Tax {
    name: string;
    current: number;
    yearToDate: number;
}
export interface Contribution {
    employee: Tax[];
    employer: Tax[];
}

export function getUSTaxContribution(payroll): Contribution {
    return {
        employee: getEmployeeContribution(payroll),
        employer: getEmployerContribution(payroll)
    }
}

export function getEmployeeContribution(payroll): Tax[] {
    let employeeTaxes: Tax[] = [];
    if (payroll && payroll.compliance) {
        const taxDetails = payroll.compliance?.taxDetails;
        if (taxDetails && taxDetails.length > 0) {
            taxDetails.filter((tax) => {
                if (tax.payeeType === "EMPLOYEE") {
                    employeeTaxes.push({
                        name: getPlainTaxName(tax.taxName, false),
                        current: tax.taxAmount,
                        yearToDate: tax.yearToDate
                    });
                }
            });
        }
    }

    return employeeTaxes;
}

export function getEmployerContribution(payroll): Tax[] {
    let employerTaxes: Tax[] = [];
    if (payroll && payroll.compliance) {
        const taxDetails = payroll.compliance?.taxDetails;
        if (taxDetails && taxDetails.length > 0) {
            taxDetails.filter((tax) => {
                if (tax.payeeType === "EMPLOYER") {
                    employerTaxes.push({
                        name: getPlainTaxName(tax.taxName, true),
                        current: tax.taxAmount,
                        yearToDate: tax.yearToDate
                    });
                }
            });
        }
    }

    return employerTaxes;
}

function getPlainTaxName(taxName: string, isEmployerTax: boolean): string {
    const searchText = isEmployerTax ? 'EMPLOYER ' : 'EMPLOYEE ';
    if (taxName && taxName.indexOf(searchText) !== -1) {
        taxName = taxName.concat(' ').replace(new RegExp(searchText, 'g'), '').trim();
    }

    let words = taxName.toLowerCase().split(' ');
    if (words && words.length > 0) {
        words = words.map((word) => {
            return String().concat(word.charAt(0).toUpperCase(), word.substring(1));
        });

        taxName = words.join(' ');
    }

    return taxName;
}

export function isUSStateComplianceEnabled(state) {
    return ApiConstants.US_COMPLIANCE_STATES.includes(state);
}
export function isShiftOvertimePlanApplicable(planName) {
    return ApiConstants.SHIFT_OVERTIME_PLANS.includes(planName);
}
